import { ReactNode } from "react";
import { Animation } from "rsuite";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCaretDown, faFilter } from "@fortawesome/free-solid-svg-icons";

export const CollapseFilter = ({
  title,
  showComponent,
  children,
  setShowComponent,
  keyWord,
  active,
}: {
  title: string;
  showComponent: boolean;
  setShowComponent: any;
  children: ReactNode;
  keyWord: "addres" | "case" | "perspectives" | "dates" | "jurisprudence";
  active: boolean;
}) => {
  return (
    <div className="searchCollapse">
      <div
        className="searchCollapseHeader"
        role="button"
        tabIndex={0}
        onClick={() => setShowComponent(keyWord, !showComponent)}
        onKeyDown={(e) => e.key === "Enter" && setShowComponent(keyWord, !showComponent)}
      >
        <div className="searchCollapseHeaderLeft">
          <FontAwesomeIcon icon={faFilter} />
          <h5 className="searchCollapseTitle">{title}</h5>
          {active && <span className="searchActivePill">ACTIVO</span>}
        </div>
        <FontAwesomeIcon
          icon={faCaretDown}
          className={`searchCollapseChevron ${showComponent ? "isOpen" : ""}`}
        />
      </div>

      <Animation.Collapse in={showComponent}>
        {(props, ref) => (
          <div ref={ref} {...props} className="searchCollapseBody">
            {children}
          </div>
        )}
      </Animation.Collapse>
    </div>
  );
};
